<template>
  <div>
    <button class="btn btn-primary" @click="toggle">
      新增Customized Filter
    </button>
    <div class="filter-dialog-wrap" v-if="filterDialogOpen">
      <v-form ref="form" @submit.prevent="saveHandler">
        <div class="filter-dialog block">
          <div class="form-item pa-5"><h3>新增Customized Filter</h3></div>
          <!-- Filter Title -->
          <label class="form-item pa-5 d-flex">
            <h4 class="w-130px mr-5">Filter Title</h4>
            <div class="flex-grow-1 flex-basis-0 my-n2">
              <v-text-field
                v-model="filterData.title"
                outlined
                dense
                :rules="titleValidation"
              ></v-text-field>
            </div>
          </label>
          <!-- Filter Option -->
          <div class="form-item pa-5 d-flex h-180px" v-if="false">
            <h4 class="w-130px mr-5">Filter Option</h4>
            <div class="flex-grow-1 flex-basis-0 my-n2 subcategory-combobox">
              <v-combobox
                v-model="filterData.options"
                :items="filterOptionItems"
                item-text="title"
                item-value="id"
                multiple
                outlined
                dense
                chips
                @change="onChange"
              >
                <template v-slot:selection="data">
                  <v-chip
                    :key="JSON.stringify(data.item)"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    :disabled="data.disabled"
                    @click:close="data.parent.selectItem(data.item)"
                    close
                  >
                    <!-- <v-avatar
                    class="accent white--text"
                    left
                    v-text="data.item.slice(0, 1).toUpperCase()"
                  ></v-avatar> -->
                    {{ data.item.title }}
                  </v-chip>
                </template>
              </v-combobox>

              <div class="h5 ink-02-medium--text mt-1">以Enter作區隔</div>
            </div>
          </div>
          <!-- actions -->
          <div class="pa-5 text-right">
            <v-btn class="btn w-100px mr-10px" @click="cancelHandler">取消</v-btn>
            <v-btn class="btn btn-primary w-100px" color="primary" type="submit">儲存</v-btn>
          </div>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required, maxLength } from '@/validation';

export default {
  data: () => ({
    isNew: false,
    titleValidation: [
      required,
      maxLength(255),
    ],
  }),
  computed: {
    ...mapState('subcategory', [
      'filterDialogOpen',
      'filterData',
      'filterOptionItems',
    ]),
  },
  methods: {
    ...mapActions('subcategory', {
      setFilterData: 'setFilterData',
      toggleFilterDialog: 'toggleFilterDialog',
    }),
    cancelHandler() {
      this.isNew = false;
      this.setFilterData({});
      this.toggleFilterDialog(false);
    },
    saveHandler() {
      if (this.$refs.form.validate()) {
        if (this.isNew) {
          this.$emit('add-filter', this.filterData);
        }
        this.isNew = false;
        this.setFilterData({});
        this.toggleFilterDialog(false);
      }
    },
    toggle() {
      this.isNew = true;
      this.toggleFilterDialog(!this.filterDialogOpen);
    },
    onChange(selectItems) {
      const item = selectItems.pop();
      if (typeof item === 'string') {
        this.filterData.options.push({
          id: null,
          title: item,
        });
      } else {
        this.filterData.options.push(item);
      }
    },
  },
};
</script>

<style lang="scss">
.filter-dialog-wrap {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(155, 155, 155, 0.5);
  z-index: 100;
}

.filter-dialog {
  width: 720px;
  margin: 0 auto;
  margin-top: 168px;
}

.subcategory-combobox {
  .v-combobox {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }

  .v-chip {
    background-color: #f7fafc !important;
    border: solid 1px #d7dee7;
  }

  .v-text-field__details {
    display: none;
  }
}
</style>
